var map = {
	"./city-ico-white.png": "2503",
	"./help-violet.png": "1fd9",
	"./history-violet.png": "1e1a",
	"./lab-violet.png": "8678",
	"./phone.png": "7f32",
	"./pinezka.png": "5fe5",
	"./recipt-violet.png": "66fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";